<template>
    <div class="slider d-flex align-items-center">
        <span class="material-symbols-outlined text-primary" @click="prevSlide"
            style="font-size: 3rem; cursor: pointer;">
            arrow_back_ios
        </span>
        <div v-if="myWebpages" class="slides d-flex overflow-hidden mr-2">
            <div v-for="(myWebpage, index) in visibleSlides" :key="index"
                class="slide flex-shrink-0 mx-1 border rounded">
                <img :title="myWebpage.name" :src="myWebpage.imgPath" class="img-fluid cursor-pointer" @click="openModal(myWebpage.id)"
                    :id="'carouselimg_' + myWebpage.id"/>
            </div>
        </div>
        <span class="material-symbols-outlined text-primary ml-2" @click="nextSlide"
            style="font-size: 3rem; cursor: pointer; ">
            arrow_forward_ios
        </span>
    </div>

    <div v-if="myWebpages" v-for="(myWebpage, index) in myWebpages" :key="index">
        <iframe-modal :id="'modal_' + myWebpage.id" :key="'modal_' + index"
            :source="myWebpage.pagebuilder_page_translations[0].route" />
    </div>
</template>

<script>
import getMyWebpages from "../composables/webpages";
import { luxonParseDate } from "../transformDate";

export default {

    name: "CarouselCard",

    setup() {
        const { myWebpages, myWebpages_error, loadMyWebpages } = getMyWebpages();
        loadMyWebpages(null, 'onlyNews');
        return { myWebpages, myWebpages_error, loadMyWebpages };
    },

    data() {
        return {
            currentIndex: 0,
        }
    },

    mounted() {

    },
    watch: {
    },
    computed: {
        visibleSlides() {
            const totalSlides = this.myWebpages.length;
            const visible = [];
            let iTs = 3;
            if (totalSlides < 3){
                iTs = totalSlides;
            }
            for (let i = 0; i < iTs; i++) {
                visible.push(this.myWebpages[(this.currentIndex + i) % totalSlides]);
            }
            return visible;
        },
    },
    methods: {
        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.myWebpages.length) % this.myWebpages.length;
        },
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.myWebpages.length;
        },
        openModal(modalIdent) {
            let modal = '#modal_' + modalIdent;
            $(modal).modal("show");
        }
    },
}
</script>


<style>
.slider {
    width: 100%;
}

.slides {
    width: 900px;
    /* Adjust based on your slide width */
}

.slide {
    width: 300px;
    /* Adjust based on your slide width */
    text-align: center;
}
</style>